import { HttpService } from '@/shared/services'
import { PayrollsConfig, PayrollsConfigList } from '../models'
import {
  PayrollIntegration,
  PayrollConfigInput,
  UpdatePayrollConfigInput,
} from './interfaces'
import List from '@/shared/dtos/List'
import PayrollConfigDetail from '../models/PayrollConfiDetail'
import GetPayrollsConfigDto from './interfaces/GetPayrollsConfigInput'
import PaginatedResult from '@/shared/dtos/PaginatedResult'

const http = new HttpService()

export const getPayrollsConfigurations = async (dto: GetPayrollsConfigDto) => {
  const { pagination, clientId, companiesIds, companyId } = dto
  const params: Record<string, string> = {}

  if (pagination?.limit !== undefined) params.limit = String(pagination.limit)
  if (pagination?.offset !== undefined)
    params.offset = String(pagination.offset)
  if (pagination?.search) params.search = pagination.search
  if (pagination?.sortField) params.sortField = pagination.sortField
  if (pagination?.sortOrder) params.sortOrder = pagination.sortOrder
  if (clientId) params.clientId = clientId
  if (companiesIds && companiesIds.length > 0)
    params.companiesIds = companiesIds.join(',')
  if (companyId) params.companyId = companyId

  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

  const endpoint = queryString
    ? `payrollConfig?${queryString}`
    : 'payrollConfig'
  const response = await http.get<PaginatedResult<PayrollsConfig>>(endpoint)
  return response.data
}

export const createPayrollConfig = async (
  payrollConfig: PayrollConfigInput
) => {
  const response = await http.post<PayrollConfigInput, string>(
    'payrollConfig',
    payrollConfig
  )

  return response.data
}

export const getPayrollConfigDetail = async (payrollConfigId: string) => {
  const response = await http.get<PayrollConfigDetail>(
    'payrollConfig/' + payrollConfigId
  )

  return response.data
}

export const getPayrollsIntegrationByCompanyId = async (companyId: string) => {
  const response = await http.get<List<PayrollIntegration[]>>(
    'payrollConfig/integration/' + companyId
  )

  return response.data
}

export const updatePayrollConfig = async (
  payrollConfigData: UpdatePayrollConfigInput,
  payrollConfigId: string
) => {
  const response = await http.put<UpdatePayrollConfigInput, string>(
    'payrollConfig/' + payrollConfigId,
    payrollConfigData
  )

  return response.data
}
